import React from "react";
import { separate } from "../../Functions/NumberSeprator";
import Style from "./FactorList.module.css";
import { ArrowRepeat, XLg } from "react-bootstrap-icons";

const FactorList = (props) => {
  // Support both props.product object or individual props
  const item = props.product || props;

  const name = item.name || "کالای بدون نام";
  const count = item.count;
  const newCount = item.new_count;
  const price = item.price;
  const newPrice = item.new_price;
  const pProductId = item.p_product_id;
  const pName = item.p_name;
  const fee = item.product_fee || item.fee || 0;
  const availability = item.availability;

  // 1. Is product unavailable?
  const isUnavailable =
    availability === "0" || availability === 0 || availability === false;

  // 2. Did the supplier replace this product?
  const isProductReplaced =
    pProductId !== undefined &&
    pProductId !== null &&
    String(pProductId) !== "0" &&
    String(pProductId) !== "";

  // 3. Did the supplier change the quantity?
  const isCountChanged =
    newCount !== undefined &&
    newCount !== null &&
    String(newCount).trim() !== "" &&
    String(newCount) !== String(count);

  // 4. Did the supplier change the unit price?
  const cleanPrice = String(price || "0").replace(/,/g, "");
  const cleanNewPrice = String(newPrice || "").replace(/,/g, "");
  const isPriceChanged =
    cleanNewPrice !== "" &&
    cleanNewPrice !== "0" &&
    parseInt(cleanNewPrice, 10) !== parseInt(cleanPrice, 10);

  // Active count & price for calculations
  const activeCount = isCountChanged ? Number(newCount) : Number(count || 1);
  const activePrice = isPriceChanged
    ? Number(cleanNewPrice)
    : Number(cleanPrice || 0);

  const totalItemPrice = activeCount * activePrice;

  return (
    <li
      className={`${Style.itemCard} ${
        isUnavailable ? Style.unavailableCard : ""
      }`}
    >
      {/* Header: Product title and modification badges */}
      <div className={Style.headerRow}>
        <div className={Style.titleGroup}>
          <span
            className={`${Style.productName} ${
              isUnavailable ? Style.strikethrough : ""
            }`}
          >
            {name}
          </span>

          <div className={Style.badgeGroup}>
            {isUnavailable && (
              <span className={Style.badgeUnavailable}>
                <XLg /> ناموجود در انبار
              </span>
            )}

            {isProductReplaced && (
              <span className={Style.badgeReplaced}>
                <ArrowRepeat /> کالای جایگزین
              </span>
            )}

            {isCountChanged && !isUnavailable && (
              <span className={Style.badgeModified}>تغییر تعداد</span>
            )}

            {isPriceChanged && !isUnavailable && (
              <span className={Style.badgeModified}>تغییر قیمت</span>
            )}
          </div>
        </div>

        {/* Total Price of this line */}
        <div className={Style.totalItemPrice}>
          <span
            className={`${Style.totalPriceVal} ${
              isUnavailable ? Style.strikethrough : ""
            }`}
          >
            {separate(totalItemPrice)}
          </span>
          <span className={Style.currency}>تومان</span>
        </div>
      </div>

      {/* If this product replaced an original order item */}
      {isProductReplaced && pName && (
        <div className={Style.replacedAlert}>
          <ArrowRepeat className={Style.replacedIcon} />
          <span>
            جایگزین شده برای محصول اولیه سفارش:{" "}
            <strong>{pName}</strong>
          </span>
        </div>
      )}

      {/* Details Row: Count, Unit Price, and Product Fee */}
      <div className={Style.detailsGrid}>
        {/* Quantity (تعداد) */}
        <div className={Style.detailItem}>
          <span className={Style.detailLabel}>تعداد:</span>
          <div className={Style.detailValue}>
            {isCountChanged ? (
              <>
                <span className={Style.oldValue}>{count}</span>
                <span className={Style.changedValue}>{newCount} عدد</span>
              </>
            ) : (
              <span>{count} عدد</span>
            )}
          </div>
        </div>

        {/* Unit Price (قیمت واحد) */}
        <div className={Style.detailItem}>
          <span className={Style.detailLabel}>قیمت واحد:</span>
          <div className={Style.detailValue}>
            {isPriceChanged ? (
              <>
                <span className={Style.oldValue}>{separate(price)}</span>
                <span className={Style.changedValue}>
                  {separate(activePrice)} تومان
                </span>
              </>
            ) : (
              <span>{separate(activePrice)} تومان</span>
            )}
          </div>
        </div>

        {/* Product Fee (کارمزد محصول) */}
        {Number(fee) > 0 && (
          <div className={Style.detailItem}>
            <span className={Style.detailLabel}>کارمزد محصول:</span>
            <span className={Style.feeValue}>{separate(fee)} تومان</span>
          </div>
        )}
      </div>
    </li>
  );
};

export default FactorList;
